export type Tone = "app" | "stage";

type ToneClasses = {
  text: string;

  muted: string;

  control: string;

  hover: string;

  popup: string;

  line: string;

  selected: string;

  active: string;

  switchOff: string;

  box: string;
};

export const TONES: Record<Tone, ToneClasses> = {
  app: {
    text: "text-ink",
    muted: "text-ink-muted",
    control: "border-line bg-surface text-ink",
    hover: "not-disabled:hover:bg-surface-raised",
    popup: "border-line bg-surface text-ink shadow-panel",
    line: "border-line",
    selected: "bg-brand-soft text-brand",
    active: "bg-surface-raised",
    switchOff: "bg-line-strong",
    box: "border-control-line bg-surface-sunken text-ink",
  },
  stage: {
    text: "text-stage-ink",
    muted: "text-stage-muted",

    control:
      "border-stage-line bg-stage-wash text-stage-ink [--autofill:var(--color-stage-raised)] [--autofill-ink:var(--color-stage-ink)]",
    hover: "not-disabled:hover:bg-stage-wash",
    popup: "border-stage-line bg-stage-overlay text-stage-ink shadow-overlay",
    line: "border-stage-line",
    selected: "bg-brand text-brand-ink",
    active: "bg-stage-wash-strong",
    switchOff: "bg-stage-control",
    box: "border-stage-control bg-stage-raised text-stage-ink",
  },
};

export function tone(which: Tone | undefined): ToneClasses {
  return TONES[which ?? "app"];
}
